///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2002-2021, Open Design Alliance (the "Alliance").
// All rights reserved.
//
// This software and its documentation and related materials are owned by
// the Alliance. The software may only be incorporated into application
// programs owned by members of the Alliance, subject to a signed
// Membership Agreement and Supplemental Software License Agreement with the
// Alliance. The structure and organization of this software are the valuable
// trade secrets of the Alliance and its suppliers. The software is also
// protected by copyright law and international treaty provisions. Application
// programs incorporating this software must include the following statement
// with their copyright notices:
//
//   This application incorporates Open Design Alliance software pursuant to a
//   license agreement with Open Design Alliance.
//   Open Design Alliance Copyright (C) 2002-2021 by Open Design Alliance.
//   All rights reserved.
//
// By use of this software, its documentation or related materials, you
// acknowledge and accept the above terms.
///////////////////////////////////////////////////////////////////////////////

import { IHttpClient } from "./IHttpClient";
import { $get, $delete, $post, $put, $XMLHttp } from "./impl/Utils";

export class HttpClient implements IHttpClient {
  serverUrl: string;
  headers: HeadersInit;
  signInUserId: string;

  constructor(serverUrl: string) {
    this.serverUrl = serverUrl;
  }

  get(relativePath: string, signal?: AbortSignal): Promise<Response> {
    return $get(`${this.serverUrl}${relativePath}`, this.headers, signal);
  }

  post(
    relativePath: string,
    body?: string | object | ArrayBuffer | Blob | globalThis.File | FormData
  ): Promise<Response> {
    return $post(`${this.serverUrl}${relativePath}`, this.headers, body);
  }

  put(
    relativePath: string,
    body?: string | object | ArrayBuffer | Blob | globalThis.File | FormData
  ): Promise<Response> {
    return $put(`${this.serverUrl}${relativePath}`, this.headers, body);
  }

  delete(relativePath: string): Promise<Response> {
    return $delete(`${this.serverUrl}${relativePath}`, this.headers);
  }

  postFile(
    relativePath: string,
    file: globalThis.File,
    onProgress?: (progress: number) => void
  ): Promise<XMLHttpRequest> {
    const data = new FormData();
    data.append("file", file);

    return $XMLHttp(`${this.serverUrl}${relativePath}`, {
      method: "POST",
      headers: this.headers,
      body: data,
      uploadProgress: onProgress,
    });
  }
}
